import { useState, useCallback } from 'react';

/**
 * Hook for managing note view dialog state
 */
export function useNoteViewDialog<T>() {
  const [selectedNote, setSelectedNote] = useState<T | null>(null);
  const [showViewDialog, setShowViewDialog] = useState(false);

  const handleRowSelection = useCallback((args: any) => {
    const selectedItem = args.data;
    setSelectedNote(selectedItem);
    setShowViewDialog(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowViewDialog(false);
    setSelectedNote(null);
  }, []);

  return {
    selectedNote,
    showViewDialog,
    handleRowSelection,
    handleClose,
  };
}
